var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "last-tickets-actions" }, [
    _c(
      "div",
      { staticClass: "action-item" },
      [
        _c(
          "Tooltip",
          {
            attrs: {
              text: _vm.translations.general_active_tickets,
              isMob: _vm.isMob,
              show: _vm.showLastTicketsTooltip,
            },
          },
          [
            _c("i", {
              directives: [
                {
                  name: "long-press",
                  rawName: "v-long-press",
                  value: 500,
                  expression: "500",
                },
              ],
              staticClass: "icon icon-refresh-a",
              on: {
                "long-press-start": function ($event) {
                  _vm.showLastTicketsTooltip = true
                },
                "long-press-stop": function ($event) {
                  _vm.showLastTicketsTooltip = false
                },
                click: _vm.refreshTicketList,
              },
            }),
          ]
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "action-item" },
      [
        _c(
          "Tooltip",
          {
            attrs: {
              text: _vm.translations.general_ticket_history,
              isMob: _vm.isMob,
              show: _vm.showTicketHistoryTooltip,
            },
          },
          [
            _c("i", {
              directives: [
                {
                  name: "long-press",
                  rawName: "v-long-press",
                  value: 500,
                  expression: "500",
                },
              ],
              staticClass: "icon icon-history",
              on: {
                "long-press-start": function ($event) {
                  _vm.showTicketHistoryTooltip = true
                },
                "long-press-stop": function ($event) {
                  _vm.showTicketHistoryTooltip = false
                },
                click: _vm.openTicketHistory,
              },
            }),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }